module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [(_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('oldpassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter your current password\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('New Password')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('New Password')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('repeatpassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please repeat password\n        ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('form', {
    attrs: {
      "name": "formcpw"
    }
  }, [_c('p', [_vm._v("\n          Current Password:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "password",
      "name": "oldpassword"
    },
    domProps: {
      "value": _vm._s(_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("New Password: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required|confirmed:repeatpassword'),
      expression: "'min:8|required|confirmed:repeatpassword'"
    }],
    attrs: {
      "type": "password",
      "name": "New Password",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Confirm Password: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "password",
      "name": "repeatpassword",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "big-btn blue",
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Update Password"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  })])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1854da36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ChangePassword.vue
// module id = 484
// module chunks = 1